// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MedicalRecordsTable-module__font-s-10___UqDcU {
  font-size: 10px !important;
}

.MedicalRecordsTable-module__font-s-12___GC7YY {
  font-size: 12px !important;
}

.MedicalRecordsTable-module__font-s-13___uZpTv {
  font-size: 13px !important;
}

.MedicalRecordsTable-module__font-s-14___FvxxZ {
  font-size: 14px !important;
}

.MedicalRecordsTable-module__font-s-15___RDC2Y {
  font-size: 15px !important;
}

.MedicalRecordsTable-module__font-s-16___7ReeV {
  font-size: 16px !important;
}

.MedicalRecordsTable-module__font-s-18___TK9zb {
  font-size: 18px !important;
}

.MedicalRecordsTable-module__font-s-20___LF4Bl {
  font-size: 20px !important;
}

.MedicalRecordsTable-module__font-s-22___BHHoI {
  font-size: 22px !important;
}

.MedicalRecordsTable-module__font-s-28___wxXam {
  font-size: 28px !important;
}

.MedicalRecordsTable-module__font-w-400___Gz5rW {
  font-weight: 400 !important;
}

.MedicalRecordsTable-module__font-w-500___ILqGP {
  font-weight: 500 !important;
}

.MedicalRecordsTable-module__font-w-600___eKOCg {
  font-weight: 600 !important;
}

.MedicalRecordsTable-module__font-w-700___hws96 {
  font-weight: 700 !important;
}

.MedicalRecordsTable-module__p-5___fA3ju {
  padding: 5px !important;
}

.MedicalRecordsTable-module__p-12___ydV7e {
  padding: 12px !important;
}

.MedicalRecordsTable-module__p-16____ypTO {
  padding: 16px !important;
}

.MedicalRecordsTable-module__p-30___SuaEr {
  padding: 30px !important;
}

.MedicalRecordsTable-module__p-b-0___gtS6z {
  padding-bottom: 0 !important;
}

.MedicalRecordsTable-module__p-b-5___ZSDUr {
  padding-bottom: 5px !important;
}

.MedicalRecordsTable-module__p-b-10___xo73B {
  padding-bottom: 10px !important;
}

.MedicalRecordsTable-module__p-b-12___Yw4_M {
  padding-bottom: 12px !important;
}

.MedicalRecordsTable-module__p-b-16___Ga7O9 {
  padding-bottom: 16px !important;
}

.MedicalRecordsTable-module__p-b-18___oAjK4 {
  padding-bottom: 18px !important;
}

.MedicalRecordsTable-module__p-b-20___Nprtn {
  padding-bottom: 20px !important;
}

.MedicalRecordsTable-module__p-b-25___qen03 {
  padding-bottom: 25px !important;
}

.MedicalRecordsTable-module__p-b-30___V6AOD {
  padding-bottom: 30px !important;
}

.MedicalRecordsTable-module__p-b-50___DlBbR {
  padding-bottom: 50px !important;
}

.MedicalRecordsTable-module__p-t-0___YXTpu {
  padding-top: 0 !important;
}

.MedicalRecordsTable-module__p-t-12___CFNbO {
  padding-top: 12px !important;
}

.MedicalRecordsTable-module__p-t-16____m0Of {
  padding-top: 16px !important;
}

.MedicalRecordsTable-module__p-t-18___O1D0R {
  padding-top: 18px !important;
}

.MedicalRecordsTable-module__p-t-20___BqXp5 {
  padding-top: 20px !important;
}

.MedicalRecordsTable-module__p-t-30___QVO81 {
  padding-top: 30px !important;
}

.MedicalRecordsTable-module__p-t-40___xxGiO {
  padding-top: 40px !important;
}

.MedicalRecordsTable-module__p-t-50___z0tl8 {
  padding-top: 50px !important;
}

.MedicalRecordsTable-module__p-l-20___hD93P {
  padding-left: 20px !important;
}

.MedicalRecordsTable-module__p-l-30___DvjI9 {
  padding-left: 30px !important;
}

.MedicalRecordsTable-module__p-l-40____pEa6 {
  padding-left: 40px !important;
}

.MedicalRecordsTable-module__p-r-16___aGs4k {
  padding-right: 16px !important;
}

.MedicalRecordsTable-module__p-r-20___t073P {
  padding-right: 20px !important;
}

.MedicalRecordsTable-module__p-r-30___ZsFU3 {
  padding-right: 30px !important;
}

.MedicalRecordsTable-module__p-r-50___hdgzi {
  padding-right: 50px !important;
}

.MedicalRecordsTable-module__p-r-60___RXGxX {
  padding-right: 60px !important;
}

.MedicalRecordsTable-module__m-b-1___RA1aI {
  margin-bottom: 1px !important;
}

.MedicalRecordsTable-module__m-b-2___BMCJC {
  margin-bottom: 2px !important;
}

.MedicalRecordsTable-module__m-b-6____Cwsk {
  margin-bottom: 6px !important;
}

.MedicalRecordsTable-module__m-b-8___Il7wc {
  margin-bottom: 8px !important;
}

.MedicalRecordsTable-module__m-b-10___dCBh3 {
  margin-bottom: 10px !important;
}

.MedicalRecordsTable-module__m-b-14___vGqfv {
  margin-bottom: 14px !important;
}

.MedicalRecordsTable-module__m-b-16___eIc6y {
  margin-bottom: 16px !important;
}

.MedicalRecordsTable-module__m-b-20___h25EG {
  margin-bottom: 20px !important;
}

.MedicalRecordsTable-module__m-b-22___k9gED {
  margin-bottom: 22px !important;
}

.MedicalRecordsTable-module__m-b-24___nbVXV {
  margin-bottom: 24px !important;
}

.MedicalRecordsTable-module__m-b-30___pY4qw {
  margin-bottom: 30px !important;
}

.MedicalRecordsTable-module__m-b-32___R_PvE {
  margin-bottom: 32px !important;
}

.MedicalRecordsTable-module__m-b-40___JKRNy {
  margin-bottom: 40px !important;
}

.MedicalRecordsTable-module__m-t-2___FIGDj {
  margin-top: 2px !important;
}

.MedicalRecordsTable-module__m-t-3___jJgLR {
  margin-top: 3px !important;
}

.MedicalRecordsTable-module__m-t-4___KB0_0 {
  margin-top: 4px !important;
}

.MedicalRecordsTable-module__m-t-5___qsq4_ {
  margin-top: 5px !important;
}

.MedicalRecordsTable-module__m-t-8___D1aO1 {
  margin-top: 8px !important;
}

.MedicalRecordsTable-module__m-t-10___nw6LX {
  margin-top: 10px !important;
}

.MedicalRecordsTable-module__m-t-15___BHNHj {
  margin-top: 15px !important;
}

.MedicalRecordsTable-module__m-t-16___EK6dV {
  margin-top: 16px !important;
}

.MedicalRecordsTable-module__m-t-20___mNPyL {
  margin-top: 20px !important;
}

.MedicalRecordsTable-module__m-t-22___A4f7F {
  margin-top: 22px !important;
}

.MedicalRecordsTable-module__m-t-30___buU0u {
  margin-top: 30px !important;
}

.MedicalRecordsTable-module__m-t-32___oWZNN {
  margin-top: 32px !important;
}

.MedicalRecordsTable-module__m-l-auto___xtghw {
  margin-left: auto !important;
}

.MedicalRecordsTable-module__m-l-4___n18qb {
  margin-left: 4px !important;
}

.MedicalRecordsTable-module__m-l-5___hE64P {
  margin-left: 5px !important;
}

.MedicalRecordsTable-module__m-l-6___uNrXT {
  margin-left: 6px !important;
}

.MedicalRecordsTable-module__m-l-8___hVU9e {
  margin-left: 8px !important;
}

.MedicalRecordsTable-module__m-l-10___R3MU5 {
  margin-left: 10px !important;
}

.MedicalRecordsTable-module__m-l-16___SfqMH {
  margin-left: 16px !important;
}

.MedicalRecordsTable-module__m-l-20____rG5f {
  margin-left: 20px !important;
}

.MedicalRecordsTable-module__m-l-24___G4daj {
  margin-left: 24px !important;
}

.MedicalRecordsTable-module__m-l-30___XKNUb {
  margin-left: 30px !important;
}

.MedicalRecordsTable-module__m-l-35___iGf3d {
  margin-left: 35px !important;
}

.MedicalRecordsTable-module__m-l-40___ftLmV {
  margin-left: 40px !important;
}

.MedicalRecordsTable-module__m-r-8___AZJbD {
  margin-right: 8px !important;
}

.MedicalRecordsTable-module__m-r-10___T9yRu {
  margin-right: 10px !important;
}

.MedicalRecordsTable-module__m-r-16___TL08j {
  margin-right: 16px !important;
}

.MedicalRecordsTable-module__m-r-20___XevZn {
  margin-right: 20px !important;
}

.MedicalRecordsTable-module__m-r-24___s3VIn {
  margin-right: 24px !important;
}

.MedicalRecordsTable-module__m-r-30___u8toS {
  margin-right: 30px !important;
}

.MedicalRecordsTable-module__m-r-40___tpdUm {
  margin-right: 40px !important;
}

.MedicalRecordsTable-module__border-r-3___L355A {
  border-radius: 3px !important;
}

.MedicalRecordsTable-module__border-r-4___Ol6KT {
  border-radius: 4px !important;
}

.MedicalRecordsTable-module__border-r-6___TSsdM {
  border-radius: 6px !important;
}

.MedicalRecordsTable-module__border-r-10___Ve2lS {
  border-radius: 10px !important;
}

.MedicalRecordsTable-module__border-r-12___gg1H3 {
  border-radius: 12px !important;
}

.MedicalRecordsTable-module__border-r-16___vRM9c {
  border-radius: 16px !important;
}

.MedicalRecordsTable-module__border-r-50___aChqO {
  border-radius: 50% !important;
}

.MedicalRecordsTable-module__primary-border___f7HUW {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalRecordsTable-module__primary-border-b___kgC_N {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalRecordsTable-module__primary-border-t___JHNR_ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalRecordsTable-module__primary-border-l___u9TBp {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalRecordsTable-module__primary-border-r___YohXW {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicalRecordsTable-module__secondary-border___iAXfI {
  border: 1px solid #637768;
}

.MedicalRecordsTable-module__secondary-border-b___vKqht {
  border-bottom: 1px solid #637768;
}

.MedicalRecordsTable-module__secondary-border-t___CgM8O {
  border-top: 1px solid #637768;
}

.MedicalRecordsTable-module__secondary-border-l___ug5Kd {
  border-left: 1px solid #637768;
}

.MedicalRecordsTable-module__secondary-border-r___NiCN7 {
  border-right: 1px solid #637768;
}

.MedicalRecordsTable-module__gap-0___Niqgr {
  gap: 0 !important;
}

.MedicalRecordsTable-module__gap-2____r1Da {
  gap: 2px !important;
}

.MedicalRecordsTable-module__gap-4___QkfG5 {
  gap: 4px !important;
}

.MedicalRecordsTable-module__gap-5___eOL_j {
  gap: 5px !important;
}

.MedicalRecordsTable-module__gap-6___gaZZU {
  gap: 6px !important;
}

.MedicalRecordsTable-module__gap-8___B2GUl {
  gap: 8px !important;
}

.MedicalRecordsTable-module__gap-10____r5MF {
  gap: 10px !important;
}

.MedicalRecordsTable-module__gap-12___CMXno {
  gap: 12px !important;
}

.MedicalRecordsTable-module__gap-14___gMM5e {
  gap: 14px !important;
}

.MedicalRecordsTable-module__gap-16___XuH6E {
  gap: 16px !important;
}

.MedicalRecordsTable-module__gap-18___NlhfH {
  gap: 18px !important;
}

.MedicalRecordsTable-module__gap-20____FYti {
  gap: 20px !important;
}

.MedicalRecordsTable-module__gap-24___o74Tu {
  gap: 24px !important;
}

.MedicalRecordsTable-module__gap-26___DrCdw {
  gap: 26px !important;
}

.MedicalRecordsTable-module__gap-30___kF0Tm {
  gap: 30px !important;
}

.MedicalRecordsTable-module__gap-32___Ic1RL {
  gap: 32px !important;
}

.MedicalRecordsTable-module__gap-40___SaDPW {
  gap: 40px !important;
}

.MedicalRecordsTable-module__gap-50___p9vQ7 {
  gap: 50px !important;
}

.MedicalRecordsTable-module__flex-1___SrRDF {
  flex: 1;
}

.MedicalRecordsTable-module__flex-none___h_ie7 {
  flex: none !important;
}

.MedicalRecordsTable-module__flex-column___fQpi_ {
  display: flex;
  flex-direction: column !important;
}

.MedicalRecordsTable-module__flex-row___ba0k9 {
  display: flex;
  flex-direction: row !important;
}

.MedicalRecordsTable-module__vertically-centered___cCFnq {
  display: flex;
  align-items: center !important;
}

.MedicalRecordsTable-module__horizontally-centered___ABtQj {
  display: flex;
  justify-content: center !important;
}

.MedicalRecordsTable-module__horizontally-end___GYaDV {
  display: flex;
  justify-content: end !important;
}

.MedicalRecordsTable-module__vertically-start___C6VPW {
  display: flex;
  align-items: start !important;
}

.MedicalRecordsTable-module__space-between___tgEan {
  display: flex;
  justify-content: space-between !important;
}

.MedicalRecordsTable-module__flex-wrap___d8HhB {
  flex-wrap: wrap !important;
}

.MedicalRecordsTable-module__height-100___TO1lC {
  height: 100%;
}

.MedicalRecordsTable-module__width-50___Lup7Y {
  width: 50% !important;
}

.MedicalRecordsTable-module__width-100___SwL6X {
  width: 100%;
}

.MedicalRecordsTable-module__cursor-pointer___qjTIN {
  cursor: pointer;
}

.MedicalRecordsTable-module__cursor-not-allowed___Vq8SM {
  cursor: not-allowed !important;
}

.MedicalRecordsTable-module__absolute-centered___nOpvv {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MedicalRecordsTable-module__absolute___gDYhu {
  position: absolute;
}

.MedicalRecordsTable-module__relative___b7igh {
  position: relative;
}

.MedicalRecordsTable-module__fixed___QinIt {
  position: fixed;
}

.MedicalRecordsTable-module__visible___Dad4I {
  opacity: 1;
}

.MedicalRecordsTable-module__invisible___cELmk {
  opacity: 0;
}

.MedicalRecordsTable-module__col-90___u1_sL {
  width: 90% !important;
}

.MedicalRecordsTable-module__col-auto___tPUD3 {
  width: auto !important;
}

.MedicalRecordsTable-module__medical-tabs____dejr {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MedicalRecordsTable-module__medical-table-new___p5lLb {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MedicalRecordsTable-module__medical-table-new___p5lLb:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MedicalRecordsTable-module__medical-table-new___p5lLb::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MedicalRecordsTable-module__medical-table-new___p5lLb::-webkit-scrollbar-track {
  display: none;
}
.MedicalRecordsTable-module__medical-table-new___p5lLb.MedicalRecordsTable-module__no-pagination___rsPaW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MedicalRecordsTable-module__medical-table-new___p5lLb.MedicalRecordsTable-module__no-pagination___rsPaW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MedicalRecordsTable-module__medical-table-new___p5lLb.MedicalRecordsTable-module__no-pagination___rsPaW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MedicalRecordsTable-module__medical-table-new___p5lLb.MedicalRecordsTable-module__no-pagination___rsPaW::-webkit-scrollbar-track {
  display: none;
}

.MedicalRecordsTable-module__medical-table-empty___Q38Oj {
  padding: 14px 40px !important;
}

.MedicalRecordsTable-module__icon-btn___RMyJO {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MedicalRecordsTable-module__search-icon___FJDh9 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MedicalRecordsTable-module__disable-select___I4hG_ {
  user-select: none;
}

.MedicalRecordsTable-module__break-word___qJ6KC {
  word-break: break-word;
}

.MedicalRecordsTable-module__popup-clear-btn___uRBNQ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MedicalRecordsTable-module__scroll-m-b-20___sSV2u {
  scroll-margin-bottom: 20px;
}

.MedicalRecordsTable-module__grid___fHZSO {
  color: #637768;
  grid-template-columns: 250px 130px 50px;
  display: grid;
}
.MedicalRecordsTable-module__grid___fHZSO .MedicalRecordsTable-module__icon___MNc_L {
  width: 16px;
  height: 16px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/MedicalRecordsTable/MedicalRecordsTable.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,uCAAA;EACA,aAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  color: get-color(greenNew, medium-dark);\n  grid-template-columns: 250px 130px 50px;\n  display: grid;\n\n  .icon {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MedicalRecordsTable-module__font-s-10___UqDcU`,
	"fontS12": `MedicalRecordsTable-module__font-s-12___GC7YY`,
	"fontS13": `MedicalRecordsTable-module__font-s-13___uZpTv`,
	"fontS14": `MedicalRecordsTable-module__font-s-14___FvxxZ`,
	"fontS15": `MedicalRecordsTable-module__font-s-15___RDC2Y`,
	"fontS16": `MedicalRecordsTable-module__font-s-16___7ReeV`,
	"fontS18": `MedicalRecordsTable-module__font-s-18___TK9zb`,
	"fontS20": `MedicalRecordsTable-module__font-s-20___LF4Bl`,
	"fontS22": `MedicalRecordsTable-module__font-s-22___BHHoI`,
	"fontS28": `MedicalRecordsTable-module__font-s-28___wxXam`,
	"fontW400": `MedicalRecordsTable-module__font-w-400___Gz5rW`,
	"fontW500": `MedicalRecordsTable-module__font-w-500___ILqGP`,
	"fontW600": `MedicalRecordsTable-module__font-w-600___eKOCg`,
	"fontW700": `MedicalRecordsTable-module__font-w-700___hws96`,
	"p5": `MedicalRecordsTable-module__p-5___fA3ju`,
	"p12": `MedicalRecordsTable-module__p-12___ydV7e`,
	"p16": `MedicalRecordsTable-module__p-16____ypTO`,
	"p30": `MedicalRecordsTable-module__p-30___SuaEr`,
	"pB0": `MedicalRecordsTable-module__p-b-0___gtS6z`,
	"pB5": `MedicalRecordsTable-module__p-b-5___ZSDUr`,
	"pB10": `MedicalRecordsTable-module__p-b-10___xo73B`,
	"pB12": `MedicalRecordsTable-module__p-b-12___Yw4_M`,
	"pB16": `MedicalRecordsTable-module__p-b-16___Ga7O9`,
	"pB18": `MedicalRecordsTable-module__p-b-18___oAjK4`,
	"pB20": `MedicalRecordsTable-module__p-b-20___Nprtn`,
	"pB25": `MedicalRecordsTable-module__p-b-25___qen03`,
	"pB30": `MedicalRecordsTable-module__p-b-30___V6AOD`,
	"pB50": `MedicalRecordsTable-module__p-b-50___DlBbR`,
	"pT0": `MedicalRecordsTable-module__p-t-0___YXTpu`,
	"pT12": `MedicalRecordsTable-module__p-t-12___CFNbO`,
	"pT16": `MedicalRecordsTable-module__p-t-16____m0Of`,
	"pT18": `MedicalRecordsTable-module__p-t-18___O1D0R`,
	"pT20": `MedicalRecordsTable-module__p-t-20___BqXp5`,
	"pT30": `MedicalRecordsTable-module__p-t-30___QVO81`,
	"pT40": `MedicalRecordsTable-module__p-t-40___xxGiO`,
	"pT50": `MedicalRecordsTable-module__p-t-50___z0tl8`,
	"pL20": `MedicalRecordsTable-module__p-l-20___hD93P`,
	"pL30": `MedicalRecordsTable-module__p-l-30___DvjI9`,
	"pL40": `MedicalRecordsTable-module__p-l-40____pEa6`,
	"pR16": `MedicalRecordsTable-module__p-r-16___aGs4k`,
	"pR20": `MedicalRecordsTable-module__p-r-20___t073P`,
	"pR30": `MedicalRecordsTable-module__p-r-30___ZsFU3`,
	"pR50": `MedicalRecordsTable-module__p-r-50___hdgzi`,
	"pR60": `MedicalRecordsTable-module__p-r-60___RXGxX`,
	"mB1": `MedicalRecordsTable-module__m-b-1___RA1aI`,
	"mB2": `MedicalRecordsTable-module__m-b-2___BMCJC`,
	"mB6": `MedicalRecordsTable-module__m-b-6____Cwsk`,
	"mB8": `MedicalRecordsTable-module__m-b-8___Il7wc`,
	"mB10": `MedicalRecordsTable-module__m-b-10___dCBh3`,
	"mB14": `MedicalRecordsTable-module__m-b-14___vGqfv`,
	"mB16": `MedicalRecordsTable-module__m-b-16___eIc6y`,
	"mB20": `MedicalRecordsTable-module__m-b-20___h25EG`,
	"mB22": `MedicalRecordsTable-module__m-b-22___k9gED`,
	"mB24": `MedicalRecordsTable-module__m-b-24___nbVXV`,
	"mB30": `MedicalRecordsTable-module__m-b-30___pY4qw`,
	"mB32": `MedicalRecordsTable-module__m-b-32___R_PvE`,
	"mB40": `MedicalRecordsTable-module__m-b-40___JKRNy`,
	"mT2": `MedicalRecordsTable-module__m-t-2___FIGDj`,
	"mT3": `MedicalRecordsTable-module__m-t-3___jJgLR`,
	"mT4": `MedicalRecordsTable-module__m-t-4___KB0_0`,
	"mT5": `MedicalRecordsTable-module__m-t-5___qsq4_`,
	"mT8": `MedicalRecordsTable-module__m-t-8___D1aO1`,
	"mT10": `MedicalRecordsTable-module__m-t-10___nw6LX`,
	"mT15": `MedicalRecordsTable-module__m-t-15___BHNHj`,
	"mT16": `MedicalRecordsTable-module__m-t-16___EK6dV`,
	"mT20": `MedicalRecordsTable-module__m-t-20___mNPyL`,
	"mT22": `MedicalRecordsTable-module__m-t-22___A4f7F`,
	"mT30": `MedicalRecordsTable-module__m-t-30___buU0u`,
	"mT32": `MedicalRecordsTable-module__m-t-32___oWZNN`,
	"mLAuto": `MedicalRecordsTable-module__m-l-auto___xtghw`,
	"mL4": `MedicalRecordsTable-module__m-l-4___n18qb`,
	"mL5": `MedicalRecordsTable-module__m-l-5___hE64P`,
	"mL6": `MedicalRecordsTable-module__m-l-6___uNrXT`,
	"mL8": `MedicalRecordsTable-module__m-l-8___hVU9e`,
	"mL10": `MedicalRecordsTable-module__m-l-10___R3MU5`,
	"mL16": `MedicalRecordsTable-module__m-l-16___SfqMH`,
	"mL20": `MedicalRecordsTable-module__m-l-20____rG5f`,
	"mL24": `MedicalRecordsTable-module__m-l-24___G4daj`,
	"mL30": `MedicalRecordsTable-module__m-l-30___XKNUb`,
	"mL35": `MedicalRecordsTable-module__m-l-35___iGf3d`,
	"mL40": `MedicalRecordsTable-module__m-l-40___ftLmV`,
	"mR8": `MedicalRecordsTable-module__m-r-8___AZJbD`,
	"mR10": `MedicalRecordsTable-module__m-r-10___T9yRu`,
	"mR16": `MedicalRecordsTable-module__m-r-16___TL08j`,
	"mR20": `MedicalRecordsTable-module__m-r-20___XevZn`,
	"mR24": `MedicalRecordsTable-module__m-r-24___s3VIn`,
	"mR30": `MedicalRecordsTable-module__m-r-30___u8toS`,
	"mR40": `MedicalRecordsTable-module__m-r-40___tpdUm`,
	"borderR3": `MedicalRecordsTable-module__border-r-3___L355A`,
	"borderR4": `MedicalRecordsTable-module__border-r-4___Ol6KT`,
	"borderR6": `MedicalRecordsTable-module__border-r-6___TSsdM`,
	"borderR10": `MedicalRecordsTable-module__border-r-10___Ve2lS`,
	"borderR12": `MedicalRecordsTable-module__border-r-12___gg1H3`,
	"borderR16": `MedicalRecordsTable-module__border-r-16___vRM9c`,
	"borderR50": `MedicalRecordsTable-module__border-r-50___aChqO`,
	"primaryBorder": `MedicalRecordsTable-module__primary-border___f7HUW`,
	"primaryBorderB": `MedicalRecordsTable-module__primary-border-b___kgC_N`,
	"primaryBorderT": `MedicalRecordsTable-module__primary-border-t___JHNR_`,
	"primaryBorderL": `MedicalRecordsTable-module__primary-border-l___u9TBp`,
	"primaryBorderR": `MedicalRecordsTable-module__primary-border-r___YohXW`,
	"secondaryBorder": `MedicalRecordsTable-module__secondary-border___iAXfI`,
	"secondaryBorderB": `MedicalRecordsTable-module__secondary-border-b___vKqht`,
	"secondaryBorderT": `MedicalRecordsTable-module__secondary-border-t___CgM8O`,
	"secondaryBorderL": `MedicalRecordsTable-module__secondary-border-l___ug5Kd`,
	"secondaryBorderR": `MedicalRecordsTable-module__secondary-border-r___NiCN7`,
	"gap0": `MedicalRecordsTable-module__gap-0___Niqgr`,
	"gap2": `MedicalRecordsTable-module__gap-2____r1Da`,
	"gap4": `MedicalRecordsTable-module__gap-4___QkfG5`,
	"gap5": `MedicalRecordsTable-module__gap-5___eOL_j`,
	"gap6": `MedicalRecordsTable-module__gap-6___gaZZU`,
	"gap8": `MedicalRecordsTable-module__gap-8___B2GUl`,
	"gap10": `MedicalRecordsTable-module__gap-10____r5MF`,
	"gap12": `MedicalRecordsTable-module__gap-12___CMXno`,
	"gap14": `MedicalRecordsTable-module__gap-14___gMM5e`,
	"gap16": `MedicalRecordsTable-module__gap-16___XuH6E`,
	"gap18": `MedicalRecordsTable-module__gap-18___NlhfH`,
	"gap20": `MedicalRecordsTable-module__gap-20____FYti`,
	"gap24": `MedicalRecordsTable-module__gap-24___o74Tu`,
	"gap26": `MedicalRecordsTable-module__gap-26___DrCdw`,
	"gap30": `MedicalRecordsTable-module__gap-30___kF0Tm`,
	"gap32": `MedicalRecordsTable-module__gap-32___Ic1RL`,
	"gap40": `MedicalRecordsTable-module__gap-40___SaDPW`,
	"gap50": `MedicalRecordsTable-module__gap-50___p9vQ7`,
	"flex1": `MedicalRecordsTable-module__flex-1___SrRDF`,
	"flexNone": `MedicalRecordsTable-module__flex-none___h_ie7`,
	"flexColumn": `MedicalRecordsTable-module__flex-column___fQpi_`,
	"flexRow": `MedicalRecordsTable-module__flex-row___ba0k9`,
	"verticallyCentered": `MedicalRecordsTable-module__vertically-centered___cCFnq`,
	"horizontallyCentered": `MedicalRecordsTable-module__horizontally-centered___ABtQj`,
	"horizontallyEnd": `MedicalRecordsTable-module__horizontally-end___GYaDV`,
	"verticallyStart": `MedicalRecordsTable-module__vertically-start___C6VPW`,
	"spaceBetween": `MedicalRecordsTable-module__space-between___tgEan`,
	"flexWrap": `MedicalRecordsTable-module__flex-wrap___d8HhB`,
	"height100": `MedicalRecordsTable-module__height-100___TO1lC`,
	"width50": `MedicalRecordsTable-module__width-50___Lup7Y`,
	"width100": `MedicalRecordsTable-module__width-100___SwL6X`,
	"cursorPointer": `MedicalRecordsTable-module__cursor-pointer___qjTIN`,
	"cursorNotAllowed": `MedicalRecordsTable-module__cursor-not-allowed___Vq8SM`,
	"absoluteCentered": `MedicalRecordsTable-module__absolute-centered___nOpvv`,
	"absolute": `MedicalRecordsTable-module__absolute___gDYhu`,
	"relative": `MedicalRecordsTable-module__relative___b7igh`,
	"fixed": `MedicalRecordsTable-module__fixed___QinIt`,
	"visible": `MedicalRecordsTable-module__visible___Dad4I`,
	"invisible": `MedicalRecordsTable-module__invisible___cELmk`,
	"col90": `MedicalRecordsTable-module__col-90___u1_sL`,
	"colAuto": `MedicalRecordsTable-module__col-auto___tPUD3`,
	"medicalTabs": `MedicalRecordsTable-module__medical-tabs____dejr`,
	"medicalTableNew": `MedicalRecordsTable-module__medical-table-new___p5lLb`,
	"noPagination": `MedicalRecordsTable-module__no-pagination___rsPaW`,
	"medicalTableEmpty": `MedicalRecordsTable-module__medical-table-empty___Q38Oj`,
	"iconBtn": `MedicalRecordsTable-module__icon-btn___RMyJO`,
	"searchIcon": `MedicalRecordsTable-module__search-icon___FJDh9`,
	"disableSelect": `MedicalRecordsTable-module__disable-select___I4hG_`,
	"breakWord": `MedicalRecordsTable-module__break-word___qJ6KC`,
	"popupClearBtn": `MedicalRecordsTable-module__popup-clear-btn___uRBNQ`,
	"scrollMB20": `MedicalRecordsTable-module__scroll-m-b-20___sSV2u`,
	"grid": `MedicalRecordsTable-module__grid___fHZSO`,
	"icon": `MedicalRecordsTable-module__icon___MNc_L`
};
module.exports = ___CSS_LOADER_EXPORT___;
